import {SET_MENU_BADGE_COUNTER, SET_NOTIFICATIONS} from "@/core/store/modules/notification/constants";

export default {
    [SET_NOTIFICATIONS](state, data) {
        state.groups = data.groups
        state.notifications = data.notifications
        state.total = data.total
        state.menu_badge_counter = data.menu_badge_counter
    },
    [SET_MENU_BADGE_COUNTER](state, data) {
        Object.assign(state.menu_badge_counter, data)
    }
}